import { useSignIn } from '@/features/auth/queries';
import { useUnAuthStackNavigation } from '@/hooks';
import { captureException } from '@/libs/logger/logger-helpers';
import { UnAuthStackParamList } from '@/navigations/types';
import { useUiStore } from '@/stores/ui-store';
import { RouteProp, useRoute } from '@react-navigation/native';
import { useCallback, useState } from 'react';
import { useShallow } from 'zustand/shallow';

export function useEnterPassword() {
  const [password, setPassword] = useState('');
  const navigation = useUnAuthStackNavigation();
  const { email } = useRoute<RouteProp<UnAuthStackParamList, 'EnterPassword'>>().params;
  const showGlobalLoading = useUiStore(useShallow(s => s.showGlobalLoading));
  const hideGlobalLoading = useUiStore(useShallow(s => s.hideGlobalLoading));
  const { mutateAsync: signIn } = useSignIn();

  const onChangePassword = useCallback((text: string) => {
    setPassword(text);
  }, []);

  const handleSignIn = useCallback(async () => {
    try {
      showGlobalLoading();
      await signIn({ email, password });
    } catch (error) {
      captureException(
        {
          error_payload: error,
        },
        { tags: { usk_log_type: 'handle_sign_in' } },
      );
    } finally {
      hideGlobalLoading();
    }
  }, [email, hideGlobalLoading, password, showGlobalLoading, signIn]);

  const handleForgotPassword = useCallback(() => {
    setPassword('');
    navigation.navigate('ForgotPassword');
  }, [navigation]);

  return {
    password,
    onChangePassword,
    handleSignIn,
    handleForgotPassword,
  };
}
